import { useEffect, useState } from "react";

export const useDebounce = <T>(value: T, delay = 150): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timeout = setTimeout(() => setDebouncedValue(value), delay);

        return () => {
            clearTimeout(timeout);
        };
    }, [value, delay]);

    return debouncedValue;
};
